<div class="template-container">
  <div class="header">
    <h1 class="title">{{ "EMAIL_TEMPLATE_EDITOR" | translate }}</h1>
  </div>
  <div class="loading" *ngIf="loading">
    <div class="spinner-border" role="status"></div>
  </div>
  <div *ngIf="!loading" class="form-card">
    <div class="d-flex justify-content-end">
      <div class="switch-container">
        <mat-slide-toggle class="switch" 
                          [(ngModel)]="templateData.useDefaultTemplate" 
                          (change)="onToggleDefault()">
          {{ "EMAIL_DEFAULT_TEMPLATE" | translate }}
        </mat-slide-toggle>
        <small class="text-muted mt-1 d-block">{{ "EMAIL_DEFAULT_TEMPLATE_INFO" | translate }}</small>
      </div>
    </div>

    <fieldset [disabled]="templateData.useDefaultTemplate">
      <!-- Subject and logo -->
      <div class="header-row flex-column d-flex">
        <label>{{ "EMAIL_SUBJECT" | translate }}</label>

        <div class="email-subject col-md-6 d-flex justify-content-start align-items-center">
          <input
            [(ngModel)]="templateData.emailSubject"
            required
            [ngClass]="{ 'is-invalid': showErrors && !templateData.emailSubject }"
            placeholder="Asunto del correo"
          />
          <span class="ms-2 text-muted">#12345</span>
        </div>
        <small class="form-text text-muted">
          {{ "EMAIL_SUBJECT_INFO" | translate }}
        </small>

        <div *ngIf="showErrors && !templateData.emailSubject" class="invalid-feedback d-block">
          {{ "REQUIRED_FIELD" | translate }}
        </div>
      </div>

      <div class="logo-section d-flex justify-content-center align-items-center">
        <img *ngIf="logoUrl" [src]="logoUrl" alt="Logo de Tienda" />
      </div>

      <div class="header-row">
        <div class="header-left">
          <label>{{ "EMAIL_STORE_NAME" | translate }}</label>
          <input [(ngModel)]="templateData.storeName" required  
                 [ngClass]="{'is-invalid': showErrors && !templateData.storeName}" 
                 placeholder="Nombre de la tienda" />
          <small class="form-text text-muted">
            {{ "EMAIL_STORE_NAME_INFO" | translate }}
          </small>
          <div *ngIf="showErrors && !templateData.storeName" class="invalid-feedback">
            {{ "REQUIRED_FIELD" | translate }}
          </div>
        </div>

        <div class="header-right">
          <label>{{ "EMAIL_BODY_TITLE" | translate }}</label>
          <input class="flex-grow-1 col-md-8" [(ngModel)]="templateData.subject" required  
                 [ngClass]="{'is-invalid': showErrors && !templateData.subject}" 
                 placeholder="Título del correo" />
          <small class="form-text text-muted">
            {{ "EMAIL_BODY_TITLE_INFO" | translate }}
          </small>
          <div *ngIf="showErrors && !templateData.subject" class="invalid-feedback">
            {{ "REQUIRED_FIELD" | translate }}
          </div>
          <label>{{ orderNumber }}</label>
        </div>
      </div>

      <hr />

      <div class="greeting col-md-8 d-flex flex-column  flex-grow-1">
        <label>{{ "EMAIL_GREETING_MESSAGE" | translate }}</label>
          <input [(ngModel)]="templateData.greeting" required  
                 [ngClass]="{'is-invalid': showErrors && !templateData.greeting}" 
                 placeholder="Ej: Hola cliente, gracias por tu compra." #greetingInput />
          <small class="text-muted m-2">
            {{ "EMAIL_RESERVED_CLIENT_NOTE" | translate }} <br />
            {{ "EMAIL_RESERVED_CLIENT_NOTE_EXAMPLE" | translate }}
          </small>
          <div *ngIf="showErrors && !templateData.greeting" class="invalid-feedback">
            {{ "REQUIRED_FIELD" | translate }}
          </div>
      </div>

      <div class="products-title col-md-8 d-flex flex-column flex-grow-1">
        <label>{{ "EMAIL_PRODUCT_TITLE" | translate }}</label>
        <input [(ngModel)]="templateData.purchasedTitle" required  
               [ngClass]="{'is-invalid': showErrors && !templateData.purchasedTitle}" 
               placeholder="Título productos" />
        <small class="text-muted mb-2">{{ "EMAIL_PRODUCT_TITLE_INFO" | translate }}</small>
        <div *ngIf="showErrors && !templateData.purchasedTitle" class="invalid-feedback">
          {{ "REQUIRED_FIELD" | translate }}
        </div>
      </div>

      <div class="product-card">
        <img [src]="product.image" class="product-image" />
        <div class="product-details">
          <label><strong>{{ product.name }}</strong></label>
          <label>{{ product.extra }}</label>

          <div>
            <input [(ngModel)]="templateData.priceLabel" required  
                   [ngClass]="{'is-invalid': showErrors && !templateData.priceLabel}" 
                   placeholder="Precio" />
            <small class="form-text text-muted">
              {{ "EMAIL_PRICE_LABEL_INFO" | translate }}
            </small>
            <div *ngIf="showErrors && !templateData.priceLabel" class="invalid-feedback">
              {{ "REQUIRED_FIELD" | translate }}
            </div>
          </div>

          <div>
            <input [(ngModel)]="templateData.quantityLabel" required  
                   [ngClass]="{'is-invalid': showErrors && !templateData.quantityLabel}" 
                   placeholder="Cantidad" />
            <small class="form-text text-muted">
              {{ "EMAIL_QUANTITY_LABEL_INFO" | translate }}
            </small>
            <div *ngIf="showErrors && !templateData.quantityLabel" class="invalid-feedback">
              {{ "REQUIRED_FIELD" | translate }}
            </div>
          </div>

          <div *ngIf="product.link">
            <input [(ngModel)]="templateData.detailsLabel" required  
                   [ngClass]="{'is-invalid': showErrors && !templateData.detailsLabel}" 
                   placeholder="Detalles" />
            <small class="form-text text-muted">
              {{ "EMAIL_DETAILS_LABEL_INFO" | translate }}
            </small>
            <div *ngIf="showErrors && !templateData.detailsLabel" class="invalid-feedback">
              {{ "REQUIRED_FIELD" | translate }}
            </div>
          </div>

          <div>
            <input [(ngModel)]="templateData.downloadPdfLabel" required  
                   [ngClass]="{'is-invalid': showErrors && !templateData.downloadPdfLabel}" 
                   placeholder="Descargar PDF" />
            <small class="form-text text-muted">
              {{ "EMAIL_PDF_LABEL_INFO" | translate }}
            </small>
            <div *ngIf="showErrors && !templateData.downloadPdfLabel" class="invalid-feedback">
              {{ "REQUIRED_FIELD" | translate }}
            </div>
          </div>
        </div>
      </div>

      <hr />

      <!-- Details section -->
      <div class="summary col-md-5 d-flex flex-column flex-grow-1">
        <label>{{ "EMAIL_DETAILS_TITLE" | translate }}</label>
        <input [(ngModel)]="templateData.detailsTitle" 
               [ngClass]="{'is-invalid': showErrors && !templateData.detailsTitle}"
               placeholder="Título de detalles" />
        <small class="text-muted d-block mb-2">{{ "EMAIL_DETAILS_TITLE_INFO" | translate }}</small>
        <div *ngIf="showErrors && !templateData.detailsTitle" class="invalid-feedback">
          {{ "REQUIRED_FIELD" | translate }}
        </div>
        <p><strong>Subtotal</strong> {{ total }}</p>
        <p><strong>Total</strong> {{ total }}</p>
      </div>

      <!-- CTA -->
      <div class="col-md-10 mt-3 d-flex flex-column">
        <label>{{ "EMAIL_CALL_TO_ACTION" | translate }}:</label>
        <input class="flex-grow-1" [(ngModel)]="templateData.ctaText" 
               [ngClass]="{'is-invalid': showErrors && !templateData.ctaText}"        
               placeholder="Haz clic aquí para ver tus productos ... "/>
        <small class="text-muted" [innerHTML]="'EMAIL_CALL_TO_ACTION_INFO' | translate"></small>
        <div *ngIf="showErrors && !templateData.ctaText" class="invalid-feedback">
          {{ "REQUIRED_FIELD" | translate }}
        </div>
      </div>

      <!-- Fecha -->
      <div class="footer-date">
        <label>{{ "EMAIL_DATE_LABEL" | translate }}:</label>
        <div class="w-40">
          <div class="d-flex align-items-center gap-2">
            <input class="flex-grow-1"
                  [(ngModel)]="templateData.dateLabel"
                  required  
                  [ngClass]="{'is-invalid': showErrors && !templateData.dateLabel}" 
                  placeholder="Fecha" />
            <label class="mb-0">{{ requestDate }}</label>
          </div>
          <small class="text-muted mt-1 d-block">
            {{ "EMAIL_DATE_LABEL_INFO" | translate }}
          </small>
          <div *ngIf="showErrors && !templateData.dateLabel" class="invalid-feedback d-block">
            {{ "REQUIRED_FIELD" | translate }}
          </div>
        </div>
      </div>


      <!-- Footer -->
      <footer class="footer d-flex justify-content-center align-items-center">
        <div class="border-start">
          <p class="m-3" *ngIf="templateData.showWebsite">{{ shopTheme[0].shopDomain }}</p>
        </div>
        <div class="border-start">
          <p class="m-3" *ngIf="templateData.showPhone">{{ templateData.phone }}</p>
        </div>
        <div class="border-start">
          <p class="m-3" *ngIf="templateData.showEmail">{{ templateData.email }}</p>
        </div>
      </footer>

      <!-- Opciones de visibilidad -->
      <div class="d-flex flex-column mt-3 col-md-4">
        <label>
          <input class="mt-2 text-center" type="checkbox" [(ngModel)]="templateData.showWebsite" />
          {{ "EMAIL_SHOW_WEBSITE" | translate }}
        </label>
        <label>
          <input class="mt-2 text-center" type="checkbox" [(ngModel)]="templateData.showPhone" />
          {{ "EMAIL_SHOW_PHONE" | translate }}
        </label>
        <label>
          <input class="mt-2 text-center" type="checkbox" [(ngModel)]="templateData.showEmail" />
          {{ "EMAIL_SHOW_EMAIL" | translate }}
        </label>
      </div>
    </fieldset>

    <div class="mt-4 text-center">
      <button class="primary-btn" (click)="saveTemplate()">{{ "SAVE" | translate }}</button>
    </div>
  </div>
</div>

<div class="modal template-confirm-modal" id="templateSuccessModal" tabindex="-1">
  <div class="modal-dialog template-modal-dialog" role="document">
    <div class="modal-content template-modal-content">
      <div class="modal-body template-modal-body">
        <div class="success-check-circle">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none"
               stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="14 26 22 34 38 18" />
          </svg>
        </div>
        <h3 class="text-center">{{ "SUCCESS" | translate }}</h3>
        <p class="text-center">{{ "EMAIL_TEMPLATE_SUCCESS" | translate }}</p>
      </div>
    </div>
  </div>
</div>

<div class="modal template-confirm-modal" id="templateRequiredModal" tabindex="-1">
  <div class="modal-dialog template-modal-dialog" role="document">
    <div class="modal-content template-modal-content">
      <div class="modal-body template-modal-body">
        <h3 class="text-center">{{ "ERROR" | translate }}</h3>
        <p class="text-center">{{ "ALL_FIELDS_REQUIRED" | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">
          {{ "CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal template-confirm-modal" id="templateErrorModal" tabindex="-1">
  <div class="modal-dialog template-modal-dialog" role="document">
    <div class="modal-content template-modal-content">
      <div class="modal-body template-modal-body">
        <h3 class="text-center">{{ "ERROR" | translate }}</h3>
        <p class="text-center">{{ "ERROR_SAVING_CHANGES" | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">
          {{ "CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
